import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { _axios } from "../../plugins/axios";
import { URL, USER } from "../../constants/constant";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Select from "react-select";
import DependantHeaderSample from "../common/dependantHeaderSample";
import ReactDatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';

class DependantCancelRescheduleRaiseAlertComponent extends Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    this.state = {
      userdata: USER.user,
      orderStatus: null,
      orderDetails: null,
      cameraToggle: false,
      sampleCollection: null,
      dependantId: this.props.match.params.dependantId.toString(),
      orderDetails: USER.orderDetails,
      cancelForm: {
        // request : '',
        remarks: "",
      },
      options: [],
      reason: null,
      date: null,
      comment: null,
      relatedOrders: [],
      showBulkModal: false,
    };

    this.getOptions = this.getOptions.bind(this);
    this.switchReason = this.switchReason.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  handleChange(event) {
    if (event.target.value && event.target.value.trim().length !== 0) {
      this.setState({
        comment: event.target.value,
      });
    } else {
      this.setState({
        comment: null,
      });
    }
  }

  switchReason(reason) {
    if (!reason.value.includes("Reschedule") && !reason.value.includes("reschedule") && reason.value !== "Other") {
      this.setState({
        comment: reason.value,
        reason: reason.value,
      });
    } else {
      this.setState({
        comment: null,
        reason: reason.value,
      });
    }
  }

  componentDidMount() {
    this.getOptions();
  }

  getOptions() {
    const that = this;
    _axios.get(URL.dev_url + "getAllRejectionReasons", { params: { visibleInRetool: 0, visibleInRunnrApp: 1 } }).then(function (res) {
      let options = [];
      res.data.reasons.forEach((i) => {
        let obj = {
          value: "",
          label: "",
        };

        obj.value = i.reason;
        obj.label = i.reason;

        options.push(obj);
      });

      that.setState(
        {
          options: options,
        },
        () => console.log("state", that.state)
      );
    });
  }

  setStartDate(date) {
    var string = this.state.reason;
    var string2 = string.concat(" ");
    const newDate = date.toLocaleString();

    var string3 = string2.concat(newDate);

    this.setState({
      date: date,
    });

    this.setState({
      comment: string3,
    });
    console.log(string3);
  }

  raiseAlert() {
    const that = this;
    let url = URL.dev_url;
    let route = url + "updateorders";
    let obj = {
      access_token: "trialTest" || USER.access_token,
      currentStatusId: 3,
      requestNextStatusId: 31,
      phleboId: this.state.userdata.phleboId,
      dependantId: this.state.dependantId,
      executeAtPatientLevel: true,
      rescheduleComment: this.state.comment,
    };

    _axios
      .post(route, obj)
      .then(function (response) {
        if (response.data.success) {
          let x = "/dependantOrders";
          that.props.history.push(x);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {
    return (
      <div className="order-details-dashboard p-b-10">
        <div>
          <div className="header-sample">
            <i className="fa fa-chevron-circle-left" onClick={this.props.history.goBack}></i>
          </div>
          <DependantHeaderSample titleCall={true} title="Choose A Rejection Reason"></DependantHeaderSample>
        </div>
        <div>
          <Container className="p-t-10 p-b-10">
            <Row>
              <Col xs={6} md={6}>
                <div className="text-align-center font-size-sm">Dependant ID</div>
                <div className="text-align-center font-size-smd bold">{this.state.dependantId}</div>
              </Col>
              <Col xs={6} md={6}>
                <div className="text-align-center font-size-sm">Name</div>
                <div className="text-align-center font-size-smd bold">
                  {this.state.orderDetails ? this.state.orderDetails.pendingOrders[0].patientDetails[0].name : ""}
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div>
          <div>
            {
              <Form onSubmit={(e) => this.handleSubmit(e)} className="p-20">
                <Row className="p-t-10">
                  <Col xs={12}>
                    <div className="font-size-ml bold">Reason: </div>
                    <Select
                      defaultValue={null}
                      isSearchable={true}
                      style={{ width: "100px" }}
                      onChange={(event) => this.switchReason(event)}
                      options={this.state.options}
                    />
                  </Col>
                </Row>

                {this.state.reason === "Other" && (
                  <Row className="p-t-10">
                    <Col xs={12} md={12}>
                      <Form.Control as="textarea" size="sm" rows={3} name="remarks" onChange={(e) => this.handleChange(e)} placeholder="Remarks" />
                    </Col>
                  </Row>
                )}

                {this.state.reason !== null && (this.state.reason.includes("Reschedule") || this.state.reason.includes("reschedule")) && (
                  <Row className="date-picker p-t-10 m-1">
                    <div className="font-size-ml bold">Pick A Date and Time:</div>
                    <ReactDatePicker
                      selected={this.state.date}
                      onChange={(date) => this.setStartDate(date)}
                      showTimeSelect
                      inputProps={{ readOnly: true }}
                      dateFormat="dd/MM/yyyy HH:mm"
                      className="form-control"
                    />
                  </Row>
                )}
              </Form>
            }
          </div>
        </div>
        <Container>
          <div className="fixed-bottom p-l-15 p-r-15 p-t-5">
            <Row>
              <Col xs={12}>
                <Button
                  variant="primary"
                  size="md"
                  block
                  className="border-curve-10"
                  disabled={this.state.comment === null}
                  onClick={() => this.raiseAlert()}
                >
                  Reject
                </Button>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    );
  }
}
export default DependantCancelRescheduleRaiseAlertComponent;
